<template lang="pug">
.heading__container(:style="{ color: logoColor }")
  router-link(:to="route")
    .heading__logo-wrapper
      christmas-tree.ml-n1(x-large)
      app-avatar.transparent(
        v-if="logo"
        :avatar="logo"
        icon="$logo"
        :size="48"
        :icon-attrs="{ size: 48 }"
        contain
      )
      v-icon(v-else size="48") $logo
      span.heading__logo-text.weight-500(v-if="!mini") Афиша #[br] мероприятий
</template>

<script>
import AppAvatar from '@/components/user-redesign/AppAvatar.vue';
import ChristmasTree from '@/components/global/ChristmasTree.vue';
import { mapGetters } from 'vuex';

export default {
  name: 'LogoHeading',

  components: {
    AppAvatar,
    ChristmasTree,
  },
  props: {
    color: { type: String, default: 'redesignPrimaryDarken' },
    mini: { type: Boolean, default: false },
  },

  computed: {
    ...mapGetters({
      settings: 'settings',
    }),
    logo() {
      return this.settings.logo;
    },
    logoColor() {
      return this.$vuetify.theme.isDark
        ? `${this.$vuetify.theme.themes.dark[this.color] ?? this.color} !important`
        : `${this.$vuetify.theme.themes.light[this.color] ?? this.color} !important`;
    },
    route() {
      // REFACTOR: временно
      // const { certificate, member } = this.$conf.ROLES;
      // if (this.$user.isAuthenticated && this.$user.hasRoles([certificate, member])) {
      //   return { name: 'redesign-home' };
      // }

      return { name: 'main' };
    },
  },
};
</script>

<style lang="scss" scoped>
.heading {
  &__container {
    display: flex;
    gap: 8px;
    align-items: center;
    color: #{$redesignPrimaryDarken} !important;
    @media (max-width: 601px) {
      align-items: flex-start;
      flex-direction: column;
    }
  }
  &__title {
    font-weight: 700;
    font-size: 24px;
    color: #{$redesignPrimaryDarken};
    text-transform: uppercase;
  }
  &__region {
    font-weight: 500;
    font-size: 14px;
    text-decoration: underline;
    white-space: nowrap;
  }

  &__logo-wrapper {
    display: flex;
    align-items: center;
    gap: 8px;
  }

  &__logo-text {
    line-height: 1.3;
  }

  &__logo-landing {
    width: 150px;
  }
}
</style>
